var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _vm._v(_vm._s(_vm.$t("pc_kng_mark_btn_point_time" /** 时间点 */))),
      ]),
      _c("form-point-time", {
        staticClass: "mt8",
        attrs: { "insert-disabled": _vm.insertDisabled },
        model: {
          value: _vm.form.time,
          callback: function ($$v) {
            _vm.$set(_vm.form, "time", $$v)
          },
          expression: "form.time",
        },
      }),
      _c("div", { staticClass: "mt24" }, [
        _vm._v(_vm._s(_vm.$t("pc_biz_udp_lbl_description" /** 描述 */))),
      ]),
      _c("yxt-input", {
        staticClass: "mt8",
        attrs: {
          type: "textarea",
          rows: 2,
          placeholder: _vm.$t(
            "pc_kng_mark_msg_key_desc" /** 请输入关键帧描述 */
          ),
          maxlength: "50",
          "show-word-limit": "",
        },
        model: {
          value: _vm.form.desc,
          callback: function ($$v) {
            _vm.$set(_vm.form, "desc", $$v)
          },
          expression: "form.desc",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }